<div class="modal-header"
  [ngClass]="headerClass ? ('modal-header-' + headerClass) : ''">
  <!--
    With a description the title and the line under it share a column beside the close button. Without
    one the title stays a direct child, as every other modal and the global `.modal-header > h3` rules
    expect.
  -->
  @if (description) {
    <div class="modal-header__titles">
      <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
      <p class="modal-header__description" [innerHTML]="description | translate"></p>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  }
  @if (!isCloseHidden) {
    <sb-button
      buttonClass="link"
      [isAutoSize]="true"
      [isDisabled]="isCloseDisabled"
      iconName="close"
      (onClick)="close()">
    </sb-button>
  }
</div>

<ng-template #titleTemplate>
  <h3 class="p-large">
    @if (iClass) {
      <i class="{{iClass}} mr-3"></i>
    }
    <span [innerHTML]="modalTitle | translate"
    [ngClass]="{'hidden-xs' : modalTitleXs}"></span>
    @if (modalTitleXs) {
      <span [innerHTML]="modalTitleXs | translate"
      class="hidden-lg hidden-md hidden-sm"></span>
    }
    @if (detail) {
      <span>
        -
        <strong>{{detail | translate}}</strong>
      </span>
    }
    @if (badgeText) {
      <sb-badge
        [badgeClass]="badgeClass"
        [iconName]="badgeIcon"
        [message]="badgeText"
      class="ml-3"></sb-badge>
    }
  </h3>
</ng-template>
